const MealData = [
    {
        id: 1,
        name: "Breakfast sandwich",
        price: 6.99,
        image: 'https://i.ibb.co/0yY5D5h/breakfast2.png',
        categories: 'Breakfast',
        description: 'How we dream about our future'
    },
    {
        id: 2,
        name: "Baked Chicken",
        price: 8.29,
        image: 'https://i.ibb.co/MM1g6mq/breakfast3.png',
        categories: 'Breakfast',
        description: 'How we dream about our future'
    },
    {
        id: 3,
        name: "Bagel and cream cheese",
        price: 7.89,
        image: ' https://i.ibb.co/Z66vDxy/breakfast4.png',
        categories: 'Breakfast',
        description: 'How we dream about our future'
    },

    {
        id: 4,
        name: "Full Breakfast fried Egg Toast Brunch",
        price: 6,
        image: ' https://i.ibb.co/B2jVjm8/breakfast5.png',
        categories: 'Breakfast',
        description: 'How we dream about our future'
    },
    {
        id: 5,
        name: "Toast Croissant Fried egg",
        price: 5.65,
        image: 'https://i.ibb.co/x1RjVpq/breakfast6.png',
        categories: 'Breakfast',
        description: 'How we dream about our future'
    },
    {
        id: 6,
        name: "Egg Benedict",
        price: 4.50,
        image: ' https://i.ibb.co/28Fp6tC/breakfast1.png',
        categories: 'Breakfast',
        description: 'How we dream about our future'
    },
    {
        id: 7,
        name: "Tarragon-Rubbed-Salmon",
        price: 6.99,
        image: 'https://i.ibb.co/h1kqJRs/lunch3.png',
        categories: 'Lunch',
        description: 'How we dream about our future'
    },
    {
        id: 8,
        name: "Indian Lunch",
        price: 8.29,
        image: 'https://i.ibb.co/MB6vKcG/lunch4.png',
        categories: 'Lunch',
        description: 'How we dream about our future'
    },
    {
        id: 9,
        name: "Fried Chicken Bento",
        price: 7.89,
        image: 'https://i.ibb.co/M5f7jhB/lunch5.png',
        categories: 'Lunch',
        description: 'How we dream about our future'
    },

    {
        id: 10,
        name: "Healthy Meal Plan",
        price: 6,
        image: 'https://i.ibb.co/Zf5QDzj/lunch6.png',
        categories: 'Lunch',
        description: 'How we dream about our future'
    },
    {
        id: 11,
        name: 'Beef Steak',
        price: 5.65,
        image: 'https://i.ibb.co/nRbJW2m/lunch1.png',
        categories: 'Lunch',
        description: 'How we dream about our future'
    },
    {
        id: 12,
        name: "Honey-Soy-Glazed Salmon with Peppers",
        price: 8.50,
        image: ' https://i.ibb.co/6nT5mGz/lunch2.png',
        categories: 'Lunch',
        description: 'How we dream about our future'
    },
    {
        id: 13,
        name: "Salmon with Grapefruit and Lenti Salad",
        price: 6.99,
        image: 'https://i.ibb.co/zrdmznV/dinner6.png',
        categories: 'Dinner',
        description: 'How we dream about our future'
    },
    {
        id: 14,
        name: "Leamony Salmon Piccata",
        price: 8.29,
        image: 'https://i.ibb.co/JHBjMj2/dinner2.png',
        categories: 'Dinner',
        description: 'How we dream about our future'
    },
    {
        id: 15,
        name: "Pork Tenderloin With Quinoa Pilaf",
        price: 7.89,
        image: 'https://i.ibb.co/VqrKF9h/dinner5.png',
        categories: 'Dinner',
        description: 'How we dream about our future'
    },

    {
        id: 16,
        name: "French Fries with Cheese",
        price: 6,
        image: 'https://i.ibb.co/dDGNr9N/dinner4.png',
        categories: 'Dinner',
        description: 'How we dream about our future'
    },
    {
        id: 17,
        name: "Garlic Butter Baked Salmon",
        price: 5.65,
        image: 'https://i.ibb.co/vzrQww0/dinner3.png',
        categories: 'Dinner',
        description: 'How we dream about our future'
    },
    {
        id: 18,
        name: "Baked Chicken",
        price: 8.50,
        image: 'https://i.ibb.co/XZHxRgB/dinner1.png',
        categories: 'Dinner',
        description: 'How we dream about our future'
    },


]

export default MealData;











